module.exports = __webpack_public_path__ + "img/001-man.f98542f8.svg";